import { render, staticRenderFns } from "./IdeaScore.vue?vue&type=template&id=59f41f0c&scoped=true"
import script from "./IdeaScore.vue?vue&type=script&lang=js"
export * from "./IdeaScore.vue?vue&type=script&lang=js"
import style0 from "./IdeaScore.vue?vue&type=style&index=0&id=59f41f0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f41f0c",
  null
  
)

export default component.exports